import { doesUrlContainParam, getParamsFromUrl } from 'utils/urls'
import { LANGUAGE_SUBDOMAINS } from 'utils/languages'
import { AllAllowedCookies, CookiesArray } from 'models/cookies'

interface UrlParams {
  [key: string]: string
}

export const getAllowedCookies = (allowedCookies: AllAllowedCookies[]): CookiesArray => {
  const cookiesArray: CookiesArray = {}
  allowedCookies.forEach((item) => {
    const cookieValue = cookieService.getItem(item)
    if (cookieValue) cookiesArray[item] = cookieValue
  })
  return cookiesArray
}

export const getCookieDomain = (domain?: string): string => {
  const regex = new RegExp(`^(${LANGUAGE_SUBDOMAINS.join('|')})\\.`)
  return (domain || location.hostname).replace(regex, '')
}

const cookieService = {
  maximalCookieTTL: 90,
  setItem: (key: string, value: string, days = 365, domain = '', sameSite = 'Lax'): void => {
    const currentDate = new Date()
    currentDate.setTime(+currentDate + days * 86400000)

    document.cookie = `${key}=${value}; path=/; domain=${getCookieDomain(
      domain,
    )}; expires=${currentDate.toUTCString()}; SameSite=${sameSite}; Secure`
  },
  getItem: (name: string): string | null => {
    if (!document.cookie) return null
    const cookies = document.cookie.split('; ')

    const cookie = cookies.find((cookie) => cookie.startsWith(`${name}=`))
    if (!cookie) return null

    return cookie.substring(name.length + 1)
  },
  removeItem(key: string, domain?: string | null): void {
    if (document.cookie) {
      const zeroTime = new Date(0)
      document.cookie = `${key}=; expires=${zeroTime.toUTCString()}${domain ? `; domain=${domain}` : ''}; path=/`
    }
  },
  extractParamsFromURL: (): UrlParams => {
    const params = new URLSearchParams(window.location.search)
    const vars: UrlParams = {}
    params.forEach((value, key) => {
      vars[key] = value
    })
    return vars
  },
  setCookieByParamUrl(paramKey: string, cookieKey: string): void {
    const urlParamsObject = getParamsFromUrl()
    if (doesUrlContainParam(paramKey, urlParamsObject))
      cookieService.setItem(cookieKey, urlParamsObject[paramKey], cookieService.maximalCookieTTL)
  },
  setupCookiesFromURL: (allowedParams: string[]): void => {
    const paramsToStore = cookieService.extractParamsFromURL()
    for (const paramName in paramsToStore) {
      if (doesUrlContainParam(paramName, paramsToStore) && allowedParams.includes(paramName)) {
        const cookieName = paramName === 'xchangerId' ? 'xchanger_id' : paramName
        cookieService.setItem(cookieName, paramsToStore[paramName], cookieService.maximalCookieTTL)
      }
    }
  },
  setupCookiesFromClient: (): void => {
    if (cookieService.getItem('ik_referrer')) {
      // TODO: Check is this code relevant for us.
      cookieService.setItem('ik_referrer', document.referrer)
    }
  },
}

export default cookieService
